<template>
  <div>
         <Modal
            :mask-closable="false"
            v-model="sportsmanListModal"
            title="运动员列表"
            :footerHide="true"
            width="900"
            @on-cancel="Sportsmancancel"
           
        >
            <div label="姓名：" class="cf userName">
                <Input class="float-l"  @input="getSportsmanListFn"  style="width:220px;" v-model="SportsmanName" placeholder="请输入运动员姓名"  />
                <Button class="float-l" type="primary"  @click="getSportsmanListFn"  icon="ios-search" >查询</Button>
                <Button type="primary" class="float-l" style="border-radius:4px!important;margin-left:12px;" :disabled="disableds"   @click="sportsmanSubmit()">确认</Button>
            </div>
            
            <table class="sportsmanTableHead sportsmanTable">
                <tr>
                    <th width="32"></th>
                    <th width="140">姓名</th>
                    <th width="60">性别</th>
                    <th width="130">注册号</th>
                    <th width="110">单位</th>
                    <th width="150">主项</th>
                    <th >身份证</th>
                </tr>
            </table>
            <div class="sportsmanTableTbody">
                <table id="sportsmanTable" class="sportsmanTable">
                    <tr @click="selectSportsman(item,index)" v-for="item,index in getSportsmanListData" :key="index">
                        <td width="32"><div class="getSportsman display-i"></div></td>
                        <td width="140">{{item.cnName}}</td>
                        <td width="60">{{item.sexString}}</td>
                        <td width="130">{{item.registerNo}}</td>
                        <td width="110">{{item.unit}}</td>
                        <td width="150">{{item.mainItem1Name}}</td>
                        <td>{{item.idCard}}</td>
                    </tr>
                    <tr  v-if="getSportsmanListData.length===0">
                        <td style="color:#ccc;text-align:center;" colspan="4">暂无数据</td>
                    </tr>
                </table>
            </div>
            
            <!-- <div class="UpBut sportsmanSubmit">
                    <Button type="primary" size="large" :disabled="disableds"   @click="sportsmanSubmit()">保存</Button>
            </div> -->
         </Modal>

        <Modal
            :mask-closable="false"
            v-model="resultForm.ModalResultList"
            :title="resultTielt()"
            :footerHide="true"
            width="900"
            @on-cancel="closeModalResultList"
        >
          <Form  ref="formValiEditResult" :model="formValiEditResult" :rules="ruleValidateResult" :label-width="120" >
            <div class="editDiv" >
                <!-- <h3 class="ti"></span></h3> -->
               
                <div v-if="getResult.property!==4" class="fromDiv" >
                    <div class="title_b">
                        <div class="title_bl">
                            基本信息
                        </div>
                    </div>
                    
                    <div class="fromDiv_l">
                        <div class="fromDiv_ll">
                            <div class="userName">
                                <FormItem label="姓名：" class="cf"  prop="familyNameCHN">
                                    <Input class="float-l" style="width:166px"  disabled  placeholder="" v-model="formValiEditResult.familyNameCHN" ></Input>
                                    <Button v-if="resultForm.addData" class="float-l" type="info"  icon="md-add"  @click="addSportsman()">选择运动员</Button>
                                </FormItem>
                            </div>
                            <FormItem label="英文姓：" class="cf hiden"  prop="enFirstName">
                                <Input class="float-l"   disabled  placeholder="" v-model="formValiEditResult.enFirstName" ></Input>
                            </FormItem>
                            <FormItem label="性别："  prop="sex">
                                <Input  placeholder="" disabled v-model="formValiEditResult.sex" ></Input>
                            </FormItem>
                             <FormItem label="注册号："  prop="iAAFAthleteCode">
                                <Input disabled  placeholder="" v-model="formValiEditResult.iAAFAthleteCode" ></Input>
                            </FormItem>
                            <FormItem label="身份证号码："  prop="iDCard">
                                <Input disabled  placeholder="" v-model="formValiEditResult.iDCard" ></Input>
                            </FormItem>
                        </div>
                        <div class="fromDiv_ll">
                            
                            <div class="uploadImg">
                                <div class="uploadImgBox">
                                    <div class="demo-upload-list" v-for="(item,index) in uploadList" :key="index">
                                        <template v-if="item.status === 'finished'">
                                            <img v-if="isImg(item.url)" :src="item.url">
                                            <span v-else><Button   @click="domFile(item.url)"><Icon type="md-cloud-download" />下载文件</Button></span>
                                            <div v-if="isImg(item.url)" class="demo-upload-list-cover">
                                                <Icon type="ios-eye-outline" @click.native="handleView(item)"></Icon>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
                                        </template>
                                    </div>
                                </div>
                               
                                <div class="uploadbox">
                                     <Upload
                                        ref="upload"
                                        :show-upload-list="false"
                                        :default-file-list="defaultList"
                                        :on-success="handleSuccess"
                                        :format="['jpg','png','zip','rar','doc','docx','pdf','xls','xlsx']"
                                        :max-size="10240"
                                        :on-format-error="handleFormatError"
                                        :on-exceeded-size="handleMaxSize"
                                        :before-upload="handleBeforeUpload"
                                        type="drag"
                                        :headers="headerData"
                                        :data="actionData"
                                        :action="actionUrl"
                                        class="uploadBut display-i" >
                                        
                                        <div>
                                            <Button v-if="!resultForm.up"  type="dashed"  icon="md-add"  >{{uploadText}}</Button>
                                        </div>
                                    </Upload>
                                </div>
                                <Modal width="1000" style="text-align:center;" title="证明文件" v-model="visible">
                                    <img  :src="imgName" v-if="visible" style="max-width:960px">
                                </Modal>
                            </div>
                           <FormItem label="英文名：" class="cf hiden"  prop="enLastName">
                                <Input class="float-l"   disabled  placeholder="" v-model="formValiEditResult.enLastName" ></Input>
                            </FormItem>
                            <FormItem label="单位："  prop="unitNameCHN">
                                <Input disabled  placeholder="" v-model="formValiEditResult.unitNameCHN" ></Input>
                            </FormItem>
                        </div>
                    </div>
                </div>
                <div class="fromDiv" v-else>
                    <div class="fromDiv_ll">
                        <FormItem label="单位："  prop="unitNameCHN">
                            <Input    :maxlength="16" placeholder="" :disabled="resultForm.up" v-model="formValiEditResult.unitNameCHN" ></Input>
                        </FormItem>
                        <FormItem label="代表队队名："  prop="teamName">
                            <Input  :maxlength="16"  :disabled="resultForm.up" placeholder="" v-model="formValiEditResult.teamName" ></Input>
                        </FormItem>
                    </div>
                    <div class="fromDiv_rl">
                        <div class="uploadImg">
                                <div class="uploadImgBox">
                                    <div class="demo-upload-list" v-for="(item,index) in uploadList" :key="index">
                                        <template v-if="item.status === 'finished'">
                                            <img v-if="isImg(item.url)" :src="item.url">
                                            <span v-else><Button   @click="domFile(item.url)"><Icon type="md-cloud-download" />下载文件</Button></span>
                                            <div v-if="isImg(item.url)" class="demo-upload-list-cover">
                                                <Icon type="ios-eye-outline" @click.native="handleView(item)"></Icon>
                                            </div>
                                           
                                        </template>
                                        <template v-else>
                                            <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
                                        </template>
                                    </div>
                                </div>
                               
                                <div class="uploadbox">
                                     <Upload
                                        ref="upload"
                                        :show-upload-list="false"
                                        :default-file-list="defaultList"
                                        :on-success="handleSuccess"
                                        :format="['jpg','png','zip','rar','doc','docx','pdf','xls','xlsx']"
                                        :max-size="1024"
                                        :on-format-error="handleFormatError"
                                        :on-exceeded-size="handleMaxSize"
                                        :before-upload="handleBeforeUpload"
                                        type="drag"
                                        :headers="headerData"
                                        :data="actionData"
                                        :action="actionUrl"
                                        class="uploadBut display-i" >
                                        
                                        <div>
                                            <Button  v-if="!resultForm.up"  type="dashed"  icon="md-add"  >{{uploadText}}</Button>
                                        </div>
                                    </Upload>
                                </div>
                                <Modal width="1000" style="text-align:center;" title="证明文件" v-model="visible">
                                    <img  :src="imgName" v-if="visible" style="max-width:960px">
                                </Modal>
                            </div>
                    </div>
                </div>
                
                <div  class="fromDiv" >
                    <div class="title_b">
                        <div class="title_bl">
                            {{getResult.event}}{{getResult.property===5 ? getResult.allEvent : ''}}
                        </div>
                    </div>
                    <div v-if="getResult.property==2" class="fromDiv_l cf">
                        
                        
                         <FormItem
                                v-for="(item, k) in formValiEditResult.details"
                                :key="k"
                                :label="'高度' + (k+1) +'：'"
                                :prop="'details.' + k + '.hight'"
                                :rules="{required: true, message: '只能为数字类型', trigger: 'blur',pattern:/^(([1-9]\d{0,3})|0)(\.\d{0,2})?$/}">
                               
                                <div>
                                    <Input disabled type="text" class="width108PX m-r10px" v-model="item.hight" placeholder="输入成绩参数值"  ></Input>
                                    <Select  :disabled="resultForm.up" v-model="formValiEditResult.details[k].value1"  class="width70PX m-r10px" >
                                        <Option v-for="item in $PlugIn.highJumData" :value="item.value" :key="item.value">{{ item.label }}</Option>
                                    </Select>
                                    <Select  :disabled="resultForm.up"  v-model="formValiEditResult.details[k].value2"  class="width70PX m-r10px" >
                                        <Option v-for="item in $PlugIn.highJumData" :value="item.value" :key="item.value">{{ item.label }}</Option>
                                    </Select>
                                    <Select  :disabled="resultForm.up"  v-model="formValiEditResult.details[k].value3"  class="width70PX m-r10px" >
                                        <Option v-for="item in $PlugIn.highJumData" :value="item.value" :key="item.value">{{ item.label }}</Option>
                                    </Select>
                                </div>
                 
                        </FormItem>
                    </div>
                    <div v-if="getResult.property==3" class="fromDiv_l cf">
                       
                        <div  v-for="(item, index) in formValiEditResult.details"
                             :key="index"
                              class="cf relayParagraph">
                             
                            <FormItem
                                    class="float-l m-r10px"
                                    :label="tyTitle(item.round) +'：'"
                                    :prop="'details.' + index + '.roundState'"
                                    :rules="{message: '成绩不能为中文', trigger: 'blur',pattern:/^(([1-9a-z-A-Z]\d{0,5})|0)(\.\d{0,5})?$/}" >
                                    <div class="cf relay">
                                       <Input  :disabled="resultForm.up" @input="roundStateChange" :maxlength="6" type="text" class="width108PX" v-model="item.roundState"  placeholder="请输入成绩"  ></Input>
                                    </div>
                            </FormItem>
                            <FormItem
                                    v-if="(getResult.event=='三级跳远'||getResult.event=='跳远')&&(getGameNames.gameTyp!==1||getGameNames.gameType!=4)"
                                    label="风速："
                                    class="float-l relay1 m-r10px"
                                    :prop="'details.' + index + '.windSpeed'"
                                    :rules="{message: '输入格式不正确', trigger: 'blur',pattern:/^(-?\d+)(\.\d+)?$/}" >
                                    <div class="cf relay">
                                        
                                        <Input :disabled="resultForm.up"  :maxlength="6" type="text" class="width108PX" v-model="item.windSpeed"  placeholder="请输入风速"  ></Input>
                                    </div>
                                    <!-- ^(\-&&1[0-9]|\d{2,6})|(1[0-9]|\d{2,6})$ -->
                            </FormItem>
                             <FormItem
                                    label="备注："
                                    class="float-l relay1 m-r10px"
                                    :prop="'details.' + index + '.recordInfo1'"
                                     >
                                    <div class="cf relay">
                                       <Input  :disabled="resultForm.up" :maxlength="26" type="text" class="width108PX" v-model="item.recordInfo1"  placeholder=""  ></Input>
                                    </div>
                            </FormItem>
                        </div>
                        

                    </div>
                    <div v-if="getResult.property==4" class="fromDiv_l cf">
                     
                        <div  v-for="(item, k) in formValiEditResult.items"
                             :key="k"
                              class="cf">
                            
                            <FormItem
                                    :label="'第' + (k+1) +'棒：'"
                                    class="float-l relay1 m-r10px"
                                    :prop="'items.' + k + '.familyNameCHN'"
                                     >
                                    <div  class="cf relay">
                                        <Input  class="float-l width108PX athletes"   disabled    type="text"  v-model="item.familyNameCHN" ></Input>
                                        <Button v-if="resultForm.addData" class="float-l athletes" type="info" @click="addSportsman(k)"  icon="md-add"  >选择运动员</Button>
                                    </div>
                            </FormItem>
                            <FormItem
                                    label="身份证号码："
                                    class="float-l m-r10px borderZ"
                                    :prop="'items.' + k + '.iDCard'"
                                     >
                                    <div  class="cf relay">
                                        <Input  class="float-l athletes"   disabled    type="text"  v-model="item.iDCard" ></Input>
                                    </div>
                            </FormItem>
                            <FormItem
                                    label="单位："
                                    class="float-l m-r10px borderZ unitNameCHN"
                                    :prop="'items.' + k + '.unitNameCHN'"
                                     >
                                    <div  class="cf relay">
                                        <Input  class="float-l athletes"   disabled    type="text"  v-model="item.unitNameCHN" ></Input>
                                    </div>
                            </FormItem>
                        </div>
                       
                    </div>
                     <div v-if="getResult.property==5" class="fromDiv_l cf">
                        <div  v-for="(item, index) in formValiEditResult.items"
                             :key="index"
                              class="cf relayParagraph">
                            <FormItem
                                    style="display:none"
                                    class="float-l m-r10px"
                                    :prop="'items.'+index+'.allEvent'">
                                    <div class="cf">
                                       <Input class="float-l width108PX athletes"   :disabled="resultForm.up" type="text"  v-model="item.allEvent" ></Input>
                                    </div>
                            </FormItem>
                            <FormItem
                                    :label="item.allEvent+'：'"
                                    class="float-l m-r10px"
                                    :prop="'items.' + index + '.showResult'" >
                                    <div class="cf">
                                        <Input class="float-l width108PX athletes"  :disabled="resultForm.up" :maxlength="10" placeholder="请输入成绩"   type="text" v-model="item.showResult" ></Input>
                                    </div>
                            </FormItem>
                             <FormItem
                                    label="得分："
                                    class="float-l relay1 m-r10px"
                                    :prop="'items.' + index + '.score'"
                                    :rules="{ message: '得分只能为整数', trigger: 'blur',pattern:/^[0-9]*$/}" >
                                    <div class="cf">
                                        <Input @input="scoreChange" :disabled="resultForm.up" class="float-l width108PX athletes"   :maxlength="6"   placeholder="请输入得分"   type="text"  v-model="item.score" ></Input>
                                    </div>
                            </FormItem>
                            <FormItem
                                    v-if="(getGameNames.gameTyp!==1||getGameNames.gameType!=4) && (item.allEvent=='100米'||item.allEvent=='200米'||item.allEvent=='100米栏'||item.allEvent=='110米栏'||item.allEvent=='三级跳远'||item.allEvent=='跳远')"
                                    label="风速："
                                    class="float-l relay1 m-r10px"
                                    :prop="'items.' + index + '.windSpeed'"
                                    :rules="{ message: '风速只能为整数', trigger: 'blur',pattern:/^(-?\d+)(\.\d+)?$/}" >
                                    <div class="cf">
                                        <Input  :disabled="resultForm.up" class="float-l width108PX athletes"   :maxlength="6"   placeholder=""   type="text"  v-model="item.windSpeed" ></Input>
                                    </div>
                            </FormItem>
                        </div>
                    </div>
                     <div v-else class="fromDiv_l cf">
                          <div class="cf">
                            <FormItem
                                     v-if="getResult.property==1||getResult.property==4||getResult.property==6||getResult.property==7"
                                    class="float-l"
                                    label="道次："
                                    prop="lane" >
                                <Input class="width108PX"  :disabled="resultForm.up"  placeholder="" :maxlength="3"  type="text"  v-model="formValiEditResult.lane" ></Input>
                            </FormItem>
                            <FormItem
                                    class="float-l"
                                    label="组号："
                                    prop="grp" >
                                <Input class="width108PX"  :disabled="resultForm.up" placeholder="" :maxlength="3"  type="text"  v-model="formValiEditResult.grp" ></Input>
                            </FormItem>
                        </div>
                     </div>
                </div>
                <div class="fromDiv" >
                    <div class="title_b">
                        <div class="title_bl">
                            最终成绩
                        </div>
                    </div>
                    <div  v-if="getResult.property!==5" class="fromDiv_l">
                        <div class="cf">
                            <FormItem class="float-l" label="名次："  prop="splace">
                                <Input  placeholder="" :disabled="resultForm.up"  :maxlength="4" v-model="formValiEditResult.splace" ></Input>
                            </FormItem>
                           
                            <FormItem class="float-l" label="成绩：" prop="showResult">
                              <Input @on-change="showResultF"   placeholder="请输入成绩" :disabled="resultForm.up || formValiEditResult.sporterState!=0&&formValiEditResult.sporterState!=-9&&formValiEditResult.sporterState!=-1&&formValiEditResult.sporterState!=-13"  :maxlength="11"  v-model="formValiEditResult.showResult" ></Input>
                            </FormItem>
                            
                             <FormItem class="float-l" label="成绩状态："  prop="sporterState">
                                <Select  :disabled="resultForm.up"  v-model="formValiEditResult.sporterState"  @on-change="schangeResult"  class="width108PX m-r10px" >
                                    <Option v-for="item in $PlugIn.stateResultData" :value="item.value" :key="item.value">{{ item.label }}</Option>
                                </Select>
                            </FormItem>
                            <FormItem  v-if="(getResult.event=='100米'||getResult.event=='200米'||getResult.event=='100米栏'||getResult.event=='110米栏')&&(getGameNames.gameTyp!==1||getGameNames.gameType!=4)" class="float-l" label="风速："  prop="windSpeed">
                                <Input   :maxlength="6"  :disabled="resultForm.up"   placeholder="" v-model="formValiEditResult.windSpeed" ></Input>
                            </FormItem>
                        </div>
                    </div>
                    <div v-else>
                        <FormItem class="float-l" label="名次："  prop="place">
                            <Input  placeholder=""  :disabled="resultForm.up"   :maxlength="6"  v-model="formValiEditResult.place" ></Input>
                        </FormItem>
                        <FormItem class="float-l" label="总得分："  prop="score">
                            <Input  placeholder=""   :disabled="resultForm.up"  :maxlength="6"  v-model="formValiEditResult.score" ></Input>
                        </FormItem>
                    </div>
                    
              
                </div>
                <div>
                    <FormItem label="备注"  prop="remark">
                        <Input class="remarkTextarea"   type="textarea" :disabled="resultForm.up"  placeholder="备注信息最多只能输入100个字符"  v-model="formValiEditResult.remark"></Input>
                    </FormItem>
                </div>
                <div :style="{ textAlign:resultForm.up?'right':'center'}" class="UpBut">
                    <Button v-bind:draggable="true" type="primary" size="large" :disabled="disableds" v-if="resultForm.addData && !resultForm.up"  @click="ResultSubmit('formValiEditResult')">保存</Button>
                    <Button v-bind:draggable="true" type="info" size="large" :disabled="disableds"   v-if="!resultForm.up"  @click="ResultSubmit('formValiEditResult',true)">保存并退出</Button>
                    
                    <Button v-bind:draggable="true" :type="resultForm.up?'info':'default'" size="large" :disabled="disableds"   @click="resultForm.ModalResultList=false">退出</Button>
                </div>
            </div>
          </Form>
        </Modal>
        <iframe :src="fileUrl" style="overflow:hidden;height:0px;width:0;" frameborder="0"></iframe>
  </div>
</template>

<script>
    //比赛成绩标志
    // #define SCORE_UNKNOWN				0
    // #define SCORE_NORMAL                0        //正常状态     NM
    // #define SCORE_DNS					-3      //弃权			DNS
    // #define SCORE_EXIT					-2      //中途退出		DNF
    // #define SCORE_DQ					-1		//犯规			DQ

    // #define SCORE_NULL					 0      //没有这一跳
    // #define SCORE_FAIL					-4		//失败			X
    // #define SCORE_PASS					-5		//通过			O
    // #define SCORE_IGNORE				-6		//免试			-
    // #define SCORE_QUIT				    -7		//退出比赛		r

    // #define SCORE_DR					-8		//请假	        DR
    // #define SCORE_DT					-9		//测试          DT
    // #define SCORE_OUT                 -10       //末位淘汰      末位淘汰
import {getEvent,getSportsmanList,getAllevent,addManual,addfareventbest,addhigheventbest,addrelayevent,addAlleventscore,getHighincrease,getRelaycrease,getEventList} from '@/lib/api/index.js'

let requiredStr = '必选项不能为空！'
export default {
  props: ['setting','gameId','resultForm','group','registerYear','sporterLimits','stampTiemY'],
  components: {
    
  },
  data(){
    var validatorResult = (rule, value, callback) => {
        // let reg = /^[0-9]*[1-9][0-9]*$/; 
        let reg = /^([1-9]\d*|[0]{1,1})$/;
        if (!value) {
                return callback();
        }else if(!reg.test(value)){
            return callback(new Error('得分只能为整数类型'));
        }else{
            return callback();
        }
    }; 

    var validatorResults = (rule, value, callback) => {
        let value1 = value.indexOf('.');
        let value2 = value.indexOf(':');
        let value3 = /[a-zA-Z-z]/;
        
        if (!value) {
                return callback();
        }else if( ((value1==-1 && value2==-1) || /[\u4E00-\u9FA5]/g.test(value)||value3.test(value)) && this.formValiEditResult.sporterState===0){
             return callback(new Error('成绩格式不正确'));
        }
        else{
            return callback();
        }
    }; 
    var validatgrp = (rule, value, callback) => {
        let reg = /^[0-9]*$/; 
        if (!value) {
                return callback();
        }else if(!reg.test(value)){
            return callback(new Error('只能整数类型'));
        }else{
            return callback();
        }
    };
    var validatsplace = (rule, value, callback) => {
        let reg = /^[0-9]*$/; 
        if (!value&&this.yzLayerName == '决赛') 
        {
            return callback(new Error('名次不能为空'));
        }else if(!reg.test(value)){
            return callback(new Error('只能整数类型'));
        }else{
            return callback();
        }
    };
    var validatint = (rule, value, callback) => {
        let reg = /^(-?\d+)(\.\d+)?$/; 
        if (!value) {
                return callback();
        }else if(!reg.test(value)){
            return callback(new Error('只能为数字类型'));
        }else if(value>100||value<-100)
        {
            return callback(new Error('风速超出范围值'));
        }else{
            return callback();
        }
    };


    return {
        yzLayerName:'',//验证是否为决赛名次为必须按字段
        fileUrl:'',
        eventListData:[],//项目列表
        showResultDefaults:'',
        actionUrl:'',
        imageUrl:'',
        uploadText:'',
        actionData:{},
        defaultList: [
          
        ],
        headerData:{
            "Authorization":`Bearer ${localStorage.Token}`,
        },
        imgName: '',
        visible: false,
        uploadList: [],
      // 成绩录入
      allEventListData:[],
      relay:true,
      SportsmanIndex:0,
      sportsmanListModal:false,
      modalResult:false,//成绩录入模态框
      disableds:false,
      getSportsmanListData:[],
      SportsmanName:'',
      formValiEditResult:{
        sporterState:0,
        items: [],
        lane:'',
        details:[],
        splace:'',
        showResult:'',
        unitNameCHN:'',
        familyNameCHN:'',
        enLastName:'',
        iDCard:'',
        iAAFAthleteCode:'',
        grp:'',
        sex:'',
        unitID:'',
        windSpeed:'',
        score:'',
        teamName:'',
        place:'',
        remark:''
      },
      getSportsmanData:{
          sex:'',
          cnName:'',
          enFirstName:'',
          enLastName:'',
          iDCard:'',
          unitID:'',
      },
      segmentation:'',
      ruleValidateResult:{
        showResult: [
              { required: true, message: requiredStr, trigger: 'blur', },
              {   validator: validatorResults,trigger: "blur" }
        ],
        sporterState:[
              {type:'number', required: true, message: requiredStr, trigger: 'blur' },
        ],
        splace: [
              {   validator: validatsplace,trigger: "blur" }
        ], 
        score: [
              { required: true, message: requiredStr, trigger: 'blur' },
              {   validator: validatorResult,trigger: "blur" }
        ], 
        unitNameCHN: [
               { required: true, message: requiredStr, trigger: 'blur', },
        ],
        grp: [
               {validator: validatgrp,trigger: "blur"  },
        ], 
        lane: [
               {validator: validatgrp,trigger: "blur"  },
        ], 
        windSpeed:[
             {validator: validatint,trigger: "blur"  },
        ],
      },
      eventList:[],
    }
  },
  computed:{
    
    gameIdUp()
    {
      return  this.resultForm.ModalResultList;
    },
    getResult(){
      return this.$store.state.unitAllData.result
    },
    getGameNames(){
      return this.$store.state.unitAllData.gameName
    },
    
  },
  watch: {
    gameIdUp(newV,oldV) {
        this.closeModalResultList();
        this.formEmpty();
        
        
        if(this.resultForm.ModalResultList)
        {
            
            this.defaultListUp();
            let itmesData = [];
            let detailsData = [];
            if(!this.resultForm.addData)
            {
                this.formValiEditResult = this.$PlugIn.deepClone(this.resultForm);
                itmesData = this.$PlugIn.deepClone(this.resultForm.items);
                detailsData = this.$PlugIn.deepClone(this.resultForm.details);
                this.formValiEditResult.sex = this.formValiEditResult.sex==1?'女':'男';
                this.formValiEditResult.place = this.formValiEditResult.place ? this.formValiEditResult.place.toString() : '';
                this.formValiEditResult.splace = this.formValiEditResult.splace ? this.formValiEditResult.splace.toString() : '';
                this.formValiEditResult.score = this.formValiEditResult.score ? this.formValiEditResult.score.toString() : 0;
                if(this.formValiEditResult.windSpeed && this.getResult.property ===1 )
                {
                    this.formValiEditResult.windSpeed = this.formValiEditResult.windSpeed/100;
                    if((this.formValiEditResult.windSpeed+'').indexOf('.')<0)
                    {
                        this.formValiEditResult.windSpeed = this.formValiEditResult.windSpeed+'.0';
                    }
                }
                this.formValiEditResult.lane = this.formValiEditResult.lane ==0 ? '' :this.formValiEditResult.lane;
                this.formValiEditResult.grp = this.formValiEditResult.grp ==0 ? '' :this.formValiEditResult.grp;
                this.formValiEditResult.sporterState = this.formValiEditResult.sporterState ? this.formValiEditResult.sporterState : 0;
                this.showResultDefaults = this.formValiEditResult.showResult;
            }else{
                this.formValiEditResult.sporterState = 0;
                this.defaultList = [];
                if(this.getResult.property!==4)
                {
                    setTimeout(()=>{
                        this.sportsmanListModal = true;
                    },200)
                    
                }
                
            }
            this.actionUp();
            if(this.getResult.property === 2)
            {
                this.formValiEditResult.details = [];
                let data = {
                    layer:this.resultForm.layer,
                    sexSortEventID:this.resultForm.sexSortEventID,
                }
                getHighincrease(data).then(res => {
                    if(res.data.code == 0){
                        console.log( res.data.data ,888)
                        res.data.data.forEach((item,index)=>{
                            if(this.resultForm.addData)
                            {
                                this.formValiEditResult.details.push({
                                    hight:item.hight,
                                    value1:'',
                                    value2:'',
                                    value3:''
                                })
                            }else{
                                this.formValiEditResult.details.push({
                                    hight:item.hight,
                                    value1:this.resultForm.details[index].roundState[0],
                                    value2:this.resultForm.details[index].roundState[1],
                                    value3:this.resultForm.details[index].roundState[2]
                                })
                            }
                            
                        })
                        
                    }else if(res.data.code == -2){
                        this.$Message.error("获取失败");
                    }else if(res.data.code==10)
                    {
                        this.$Message.info("登录token过期请重新登录");
                        this.$store.dispatch('loginOut');
                    }else{
                        this.$Message.error(res.data.msg);
                    }
                },err =>{
                    this.$Message.error("网络连接失败");
                });
            }else if(this.getResult.property === 3)
            {
                this.tyData(detailsData);
            }else if(this.getResult.property === 4)
            {
                let _this = this;
                this.formValiEditResult.items = [];
                let data =  {
                    event:_this.resultForm.event,
                    gameId:_this.gameId
                }
                
                getRelaycrease(data).then(res => {
                    if(res.data.code == 0){
                        let num = res.data.data.relaySporterNum ? res.data.data.relaySporterNum : 0;
                        for(let i = 0; i<num;i++)
                        {
                            if(this.resultForm.addData||!this.resultForm.items.length)
                            {
                                this.formValiEditResult.items.push({
                                    familyNameCHN:'',
                                    enFirstName:'',
                                    sex:'',
                                    unitNameCHN:'',
                                    enLastName:'',
                                    iDCard:'',
                                    iAAFAthleteCode:'',
                                    bib:''
                                })
                            }else{
                                this.formValiEditResult.items.push({
                                    familyNameCHN:this.resultForm.items[i].familyNameCHN?this.resultForm.items[i].familyNameCHN:'',
                                    enFirstName:this.resultForm.items[i].enFirstName?this.resultForm.items[i].enFirstName:'',
                                    sex:this.resultForm.items[i].sex?this.resultForm.items[i].sex:'',
                                    unitNameCHN:this.resultForm.items[i].unitNameCHN?this.resultForm.items[i].unitNameCHN:'',
                                    enLastName:this.resultForm.items[i].enLastName?this.resultForm.items[i].enLastName:'',
                                    iDCard:this.resultForm.items[i].iDCard?this.resultForm.items[i].iDCard:'',
                                    iAAFAthleteCode:this.resultForm.items[i].iAAFAthleteCode?this.resultForm.items[i].iAAFAthleteCode:'',
                                    bib:this.resultForm.items[i].bib?this.resultForm.items[i].bib:'',
                                })
                            }
                            
                        }
                    }else if(res.data.code == -2){
                        this.$Message.error("获取失败");
                    }else if(res.data.code==10)
                    {
                        this.$Message.info("登录token过期请重新登录");
                        this.$store.dispatch('loginOut');
                    }else{
                        this.$Message.error(res.data.msg);
                    }
                },err =>{
                    this.$Message.error("网络连接失败");
                });
            }else if(this.getResult.property === 5)
            {
                this.formValiEditResult.items = [];
                getAllevent(this.resultForm.sexSortEventID).then(res => {
                    if(res.data.code == 0){
                        res.data.data.forEach((item,i) => {
                            
                            if(this.resultForm.addData||!this.resultForm.items.length)
                            {
                                this.formValiEditResult.items.push({
                                    showResult:'',
                                    score:'',
                                    windSpeed:'',
                                    allProp:item.allProp,
                                    allEvent:item.allEvent
                                });
                            }else{
                                
                                if(this.resultForm.items[i].windSpeed)
                                {   
                                    itmesData[i].windSpeed = itmesData[i].windSpeed/100;
                                    if((itmesData[i].windSpeed+'').indexOf('.')<0)
                                    {
                                        
                                        itmesData[i].windSpeed = itmesData[i].windSpeed+'.0';
                                    }
                                }
                                this.formValiEditResult.items.push({
                                    showResult:this.resultForm.items[i].showResult?this.resultForm.items[i].showResult:'',
                                    score:this.resultForm.items[i].score?this.resultForm.items[i].score:0,
                                    allProp:this.resultForm.items[i].allProp?this.resultForm.items[i].allProp:'',
                                    windSpeed:itmesData[i].windSpeed?itmesData[i].windSpeed:'',
                                    allEvent:this.resultForm.items[i].allEvent?this.resultForm.items[i].allEvent:'',
                                });
                            }
                        });
                    
                    }else if(res.data.code == -2){
                        this.$Message.error("获取失败");
                    }else if(res.data.code==10)
                    {
                        this.$Message.info("登录token过期请重新登录");
                        this.$store.dispatch('loginOut');
                    }else{
                        this.$Message.error(res.data.msg);
                    }
                },err =>{
                    this.$Message.error("网络连接失败");
                });
            }
        }
       
    }
  },
  methods:{
       
        domFile(url)
        {
            let time =new Date().getTime();
            this.fileUrl = `${url}&isDownload=true&time=${time}`;
        },
        isImg(url)
        {
            if(url)
            {
                if(url.indexOf('.jpg')!=-1||url.indexOf('.JPG')!=-1||url.indexOf('.PNG')!=-1||url.indexOf('.png')!=-1)
                {
                    return true;
                }else{
                    return false;
                }
            }
        },
        showResultF()
        {
            let showResult = this.formValiEditResult.showResult;
            let _index = showResult.indexOf("。");
            if(showResult.indexOf("：")!=-1)
            {
                this.formValiEditResult.showResult.replace(/\:/g,"：")
            }
            if(_index!=-1)
            {
                let str1 =  showResult.substring(0,_index)+'.';
                let str2 =  showResult.substring(_index+1);
                this.formValiEditResult.showResult = str1+str2;
            }
            
        },
        juhao(ResultsR)//判断.后面的数据处理
        {
            if(ResultsR.length>=2)//小数点后面有2-3位数
            {
                ResultsR = parseInt(ResultsR)+"";
                if(ResultsR.length>2)
                {
                    ResultsR = parseInt(ResultsR);
                }else{
                    ResultsR = parseInt(ResultsR)*10;
                }
            }else if(ResultsR.length===1)//小数点后面有1位数
            {
                ResultsR = ResultsR+'00';
                ResultsR = parseInt(ResultsR);
            }
            return ResultsR;
        },
        maohao(splits,ResultsLArr,Results)//判断：后面的数据处理
        {
            if(splits===1)
            {
                if(ResultsLArr[0].length<2)
                {
                    Results = "00:0"+ResultsLArr[0];
                }else{
                    Results = "00:"+ResultsLArr[0];
                }
                if(ResultsLArr[1].length<2)
                {
                    Results = Results+":0"+ResultsLArr[1];
                }else{
                    Results = Results+":"+ResultsLArr[1];
                }
            }
            else if(splits===2)
            {
                if(ResultsLArr[0].length<2)
                {
                    Results = "0"+ResultsLArr[0];
                }else{
                    Results = ResultsLArr[0];
                }
                if(ResultsLArr[1].length<2)
                {
                    Results = Results+":0"+ResultsLArr[1];
                }else{
                    Results = Results+":"+ResultsLArr[1];
                }
                if(ResultsLArr[2].length<2)
                {
                    Results = Results+":0"+ResultsLArr[2];
                }else{
                    Results = Results+":"+ResultsLArr[2];
                }
                
            }else{
                if(ResultsLArr.length<=1)
                {
                    Results = "00:00:0"+ResultsLArr;
                }else
                {
                     Results = "00:00:"+ResultsLArr;
                }
            }
            return Results;
            
        },
        getMs(time)
        {
            return new Date(`1970-01-01T${time}Z`).valueOf();
        },
        resultScope()//验证成绩值范围
        {
             //验证不能大于世界记录20%
            let Results = this.formValiEditResult.showResult;
            let splits = Results.split(":").length-1;
            
            if(this.getResult.property===1||this.getResult.property===4||this.getResult.property===6||this.getResult.property===7||this.getResult.property===8)
            {
                
                if(Results.indexOf(':')!==-1&&Results.indexOf('.')!==-1)
                {
                   
                    let _index2 = Results.indexOf('.');
                    let ResultsL = Results.substring(0,_index2);
                    let ResultsR =  Results.substring(_index2+1);
                    
                    ResultsR = this.juhao(ResultsR);//判断.后面的数据处理
                    let ResultsLArr = ResultsL.split(":");
                    
                    Results = this.maohao(splits,ResultsLArr,Results);//判断：后面的数据处理
                    
                    Results = this.getMs(Results)+ResultsR
                    
                }
                else if(Results.indexOf(':')!==-1)
                {
                    let ResultsLArr = Results.split(":");
                    Results = this.maohao(splits,ResultsLArr,Results);//判断：后面的数据处理
                    Results = this.getMs(Results);
                }
                else if(Results.indexOf('.')!==-1)
                {
                   let _index2 = Results.indexOf('.');
                   let ResultsR =  Results.substring(_index2+1);
                   ResultsR = this.juhao(ResultsR);//判断.后面的数据处理

                   let ResultsL = Results.substring(0,_index2);
                   
                   Results = this.maohao(splits,ResultsL,Results);//判断：后面的数据处理
                   
                   Results = this.getMs(Results)+ResultsR;
                }
            }else if(this.getResult.property===2||this.getResult.property===3)
            {
                Results = Results*100;
            }
            return Results;
        },
        defaultListUp()
        {
            if(this.resultForm.imageUrl)
            {
                this.defaultList = [
                    {
                        'url': `${this.$imgUrl}/api/resources/respource?path=${this.resultForm.imageUrl}`,
                        'name':'imgs'
                    }
                ]
            }else{
                this.defaultList = [];
            }
            setTimeout(() => {
                this.uploadList = this.$refs.upload.fileList;
            }, 200);
        },
        actionUp()
        {
            if(!this.resultForm.addData)
            {
                this.actionUrl = this.$imgUrl+'/admin/audit/update/image';
                let id = '';
                if(this.getResult.property==4)
                {
                    id = this.formValiEditResult.relayEventID;
                }else if(this.getResult.property==5)
                {
                    id = this.formValiEditResult.allEventScoreID;
                }else if(this.getResult.property==2)
                {
                    id = this.formValiEditResult.highEventBestID;
                }else if(this.getResult.property==3)
                {
                    id = this.formValiEditResult.farEventBestID;
                }
                else{
                  id = this.formValiEditResult.runEventID;  
                }
                
                this.actionData = {
                    property:this.formValiEditResult.property,
                    id:id
                }
                this.uploadText = '修改证明文件';
            }else{
                
                this.actionUrl = this.$imgUrl+'/admin/upload/performance/audit';
                this.actionData = {

                }
                this.uploadText = '上传证明文件';
            }
        },
        handleView (obj) {
            this.imgName = obj.url;
            this.visible = true;
        },
        handleRemove (file) {
            const fileList = this.$refs.upload.fileList;
            this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
        },
        handleSuccess (res, file,fileList) {
            console.log(res, file,fileList)
            if(this.$refs.upload.fileList.length>1)
            {
                this.$refs.upload.fileList.splice(0, 1);
            }
            if(res.code===0)
            {
                
                this.$Message.info("上传成功");
                this.imageUrl = res.data;
                if(!this.resultForm.addData)
                {
                    this.$emit('resultUp');   
                    // this.$Message.info("上传成功");
                }
                file.url = `${this.$imgUrl}/api/resources/respource?path=${res.data}`;
            }else{
                this.$Message.error(res.msg);
            }
            
        },
        handleFormatError (file) {
            this.$Notice.warning({
                title: '文件格式不正确',
                desc: '文件格式的 ' + file.name + ' 不正确，请选择jpg或png。'
            });
        },
        handleMaxSize (file) {
            this.$Notice.warning({
                title: '超过文件大小限制',
                desc: '图片不能大于1M'
            });
        },
        handleBeforeUpload () {
            const check = this.uploadList.length < 2;
            if (!check) {
                this.$Notice.warning({
                    title: '最多只能上传一张图片'
                });
            }
            return check;
        },
      schangeResult(value)
      {
          let key = '';
          this.$PlugIn.stateResultData.filter((v,k)=>{
             
              if(v.value==value)
              {
                  key = v.value==0 || v.value==-1 || v.value==-9 || v.value==-13? this.showResultDefaults : v.label;
              }
          });
          
          this.formValiEditResult.showResult = key;
      },
      scoreChange(ev)
      {
        let score = 0;
        this.formValiEditResult.items.forEach((v)=>{
            let value = v.score ? parseInt(v.score) : 0;
            score+=value;
        })
        this.formValiEditResult.score = score.toString();
      },
      roundStateChange()
      {
        let roundState = [];
        this.formValiEditResult.details.forEach((v)=>{
            if(Number(v.roundState))
            {
                roundState.push(Number(v.roundState))
            }
        });
        let siund = Math.max.apply(null, roundState).toString();
        this.formValiEditResult.showResult = siund == '-Infinity' ? '' :  siund.indexOf('.') ===-1 ? siund+'.0':siund; 
      },
      formEmpty()
      {
          this.formValiEditResult = {
            sporterState:0,
            items: [],
            lane:'',
            details:[],
            splace:'',
            showResult:'',
            unitNameCHN:'',
            familyNameCHN:'',
            enLastName:'',
            iDCard:'',
            iAAFAthleteCode:'',
            grp:'',
            sex:'',
            windSpeed:'',
            score:'',
            teamName:'',
            place:''
        }
      },
      tyTitle(round)//田远标题
      {
        let str = '';
        if(this.getResult.event === '跳远' || this.getResult.event === '三级跳远')
        {
            str =  "第"+round+"跳";
        }else{
            str =  "第"+round+"投";
        }
        
        return str;
      },
      tyData(detailsData)
      {
          let arr = [];
          let layerNum = this.resultForm.layer===1?7:4;
            for(let i = 1; i < layerNum; i++)
            {
                let _index = i-1;
                if(this.resultForm.addData||!this.resultForm.details.length)
                {   
                    arr.push({
                        round: i,
                        roundState:'',
                        windSpeed:'',
                        windNow:0,
                        recordInfo1:'',
                    });
                }else{
                    
                    if(detailsData[_index].windSpeed && detailsData[_index].windSpeed<10000)
                    {
                        detailsData[_index].windSpeed = detailsData[_index].windSpeed/100;
                        if((detailsData[_index].windSpeed+'').indexOf('.')<0)
                        {
                            detailsData[_index].windSpeed = detailsData[_index].windSpeed+'.0';
                        }
                        
                    }
                     arr.push({
                        round: i,
                        roundState:this.resultForm.details[_index].roundState?this.resultForm.details[_index].roundState:'',
                        windSpeed:detailsData[_index].windSpeed && detailsData[_index].windSpeed<10000?detailsData[_index].windSpeed:'',
                        windNow:0,
                        recordInfo1:this.resultForm.details[_index].recordInfo1?this.resultForm.details[_index].recordInfo1:'',
                    });
                }
            }
        
            
            this.formValiEditResult.details = arr;
    
          
      },
      resultTielt()
      {
          let layerName = this.getResult.property===5 ? '' : this.getResult.layerName;
          this.yzLayerName = layerName;
          return this.getGameNames.gameNameCHN+'（'+this.getResult.sexSortName+this.getResult.event+layerName+'）'
      },
      ResultSubmit(name,eit)
      {
         
         this.$refs[name].validate((valid) => { 
                if (valid) {
                    if(this.formValiEditResult.sporterState===0||this.formValiEditResult.sporterState===-9||this.formValiEditResult.sporterState===-1||this.formValiEditResult.sporterState===-13)
                    {

                        if(this.getResult.property!=5)
                        {
                            const result = parseInt(this.resultScope());
                            if(result)
                            {
                                let sexSortNameIndex = this.getResult.sexSortName.indexOf("男子");
                                if(sexSortNameIndex!==-1)
                                {
                                    sexSortNameIndex = 'manMax';
                                }else{
                                    sexSortNameIndex = 'womanMax';
                                }
                                let resultRecordM = 0;
                                let resultRecord = 0;      

                                this.eventListData.filter((item)=>{
                                    if(this.getResult.event===item.name)
                                    {
                                        console.log(this.getResult.event,item.womanMax)
                                        resultRecordM = sexSortNameIndex === 'manMax'?item.manMax||0:item.womanMax||0;
                                        resultRecord = sexSortNameIndex === 'manMax'?item.showManMax||0:item.showWomanMax||0;
                                    }
                                })
                                
                                if(this.getResult.property===2||this.getResult.property===3)
                                {
                                    if(result>resultRecordM && resultRecord)
                                    {
                                        
                                        this.$Modal.confirm({
                                            title: '成绩已超过世界记录，确认是有效成绩吗？',
                                            content: `<p>世界记录成绩值：${resultRecord}</p>你输入的成绩值：${this.formValiEditResult.showResult}<p></p>`,
                                            onOk: () => {
                                                this.ResultSubmitF(name,eit);
                                            },
                                        });
                                    }else{
                                        this.ResultSubmitF(name,eit);
                                    }
                                }else{
                                    if(result<resultRecordM && resultRecord)
                                    {
                                        
                                        this.$Modal.confirm({
                                            title: '成绩已超过世界记录，确认是有效成绩吗？',
                                            content: `<p>世界记录成绩值：${resultRecord}</p>你输入的成绩值：${this.formValiEditResult.showResult}<p></p>`,
                                            onOk: () => {
                                                this.ResultSubmitF(name,eit);
                                            },
                                        });
                                    }else{
                                        this.ResultSubmitF(name,eit);
                                    }
                                }

                                
                                
                                
                            }else{
                                this.$Message.error("成绩格式输入有误");
                            }
                        }else{
                            this.ResultSubmitF(name,eit);
                        }
                        
                    }else{
                        
                        this.ResultSubmitF(name,eit);
                    }
                        
                        
                }
         });
      },
      ResultSubmitF(name,eit)
      {
            this.formValiEditResult.gameID = this.gameId;
            this.formValiEditResult.sexSortEventLayerID = this.resultForm.sexSortEventLayerID ? this.resultForm.sexSortEventLayerID : -1;
            this.formValiEditResult.sexSortEventID = this.resultForm.sexSortEventID;
            this.formValiEditResult.property = this.getResult.property;
            this.formValiEditResult.sexSortEventLayerGrpID = this.formValiEditResult.sexSortEventLayerGrpID?this.formValiEditResult.sexSortEventLayerGrpID:-1;
            this.formValiEditResult.sporterID = this.formValiEditResult.sporterID?this.formValiEditResult.sporterID:-1;
            this.formValiEditResult.result = 0;
            this.formValiEditResult.allProp = this.getResult.property===5 ? this.getResult.property : 0;
            this.formValiEditResult.grp=this.formValiEditResult.grp==='' ? 0:this.formValiEditResult.grp;
            this.formValiEditResult.sex = this.formValiEditResult.sex=='女' || this.formValiEditResult.sex==1 ? 1 : 0;
         
            this.formValiEditResult.sexSortName = this.getResult.sexSortName;
            this.formValiEditResult.event = this.getResult.event;
            
            if(this.imageUrl)
            {
                this.formValiEditResult.imageUrl = this.imageUrl;
            }
            if(this.getResult.property===1||this.getResult.property===6||this.getResult.property===7||this.getResult.property===8)
            {
                let data =  this.$PlugIn.deepClone(this.formValiEditResult);
                data.windSpeed = data.windSpeed ? Number(data.windSpeed)*100 : '';
                this.formValiEditResult.runEventID = this.formValiEditResult.runEventID?this.formValiEditResult.runEventID:-1;
                data.runEventID = this.formValiEditResult.runEventID?this.formValiEditResult.runEventID:-1;
                addManual(data).then( (res) => {
                    this.MessageFn(res,eit);
                }).catch((error) => {
                })
            }else if(this.getResult.property===3)
            {
                this.formValiEditResult.order = 0;
                this.formValiEditResult.place = 0;
                this.formValiEditResult.farEventBestID = this.formValiEditResult.farEventBestID ? this.formValiEditResult.farEventBestID : -1;
                let farwindSpeed = true;
                this.formValiEditResult.details.forEach((v,k)=>{
                    if(this.formValiEditResult.details[k].windSpeed)
                    {
                        this.formValiEditResult.details[k].windSpeed = Number(v.windSpeed);
                        if(this.formValiEditResult.details[k].windSpeed && (this.formValiEditResult.details[k].windSpeed>100||this.formValiEditResult.details[k].windSpeed<-100))
                        {
                            farwindSpeed = false;
                            return false;
                        }
                    }
                })
                if(farwindSpeed)
                {
                    let data =  this.$PlugIn.deepClone(this.formValiEditResult);
                    data.details.forEach((v,k)=>{
                        if(data.details[k].windSpeed)
                        {
                            data.details[k].windSpeed = Number(v.windSpeed)*100;
                        }else{
                            data.details[k].windSpeed = '';
                        }
                    });

                     // this.formValiEditResult.details.forEach((v,k)=>{
                    //     if(this.formValiEditResult.details[k].windSpeed)
                    //     {
                    //         this.formValiEditResult.details[k].windSpeed = Number(v.windSpeed)*100;
                    //     }
                    // });
                    addfareventbest(data).then( (res) => {
                        this.MessageFn(res,eit);
                    
                    }).catch((error) => {
                    })
                }else{
                    this.$Message.error('风速超出范围值！');
                }
                
            }else if(this.getResult.property===2)
            {
                this.formValiEditResult.order = 0;
                this.formValiEditResult.place = 0;
                this.formValiEditResult.highEventBestID = this.formValiEditResult.highEventBestID ? this.formValiEditResult.highEventBestID : -1;
                this.formValiEditResult.details.forEach((v,k) => {
                    v.roundState = this.formValiEditResult.details[k].value1 + this.formValiEditResult.details[k].value2 + this.formValiEditResult.details[k].value3
                });
                
                addhigheventbest(this.formValiEditResult).then( (res) => {
                    this.MessageFn(res,eit);
                }).catch((error) => {
                })
            }else if(this.getResult.property===4){
                this.formValiEditResult.place = 0;
                this.formValiEditResult.unitRelayEventID = this.formValiEditResult.unitRelayEventID ? this.formValiEditResult.unitRelayEventID : -1;
                this.formValiEditResult.relayEventID = this.formValiEditResult.relayEventID ? this.formValiEditResult.relayEventID : -1;
                this.formValiEditResult.lane = this.formValiEditResult.lane ==='' ? 0 :this.formValiEditResult.lane;

                let validataSportsman = this.formValiEditResult.items.some(item => {
                    return item.familyNameCHN!=='';
                });
                addrelayevent(this.formValiEditResult).then( (res) => {
                    this.MessageFn(res,eit);
                }).catch((error) => {
                })
                
            }else if(this.getResult.property===5){
                this.formValiEditResult.allEventScoreID = this.formValiEditResult.allEventScoreID ? this.formValiEditResult.allEventScoreID : -1;
                this.formValiEditResult.lane = this.formValiEditResult.lane ==='' ? 0 :this.formValiEditResult.lane;
                let allAindSpeed = true;
                this.formValiEditResult.items.forEach((v,k)=>{
                    if(this.formValiEditResult.items[k].windSpeed)
                    {
                        this.formValiEditResult.items[k].windSpeed = Number(v.windSpeed);
                        if(this.formValiEditResult.items[k].windSpeed && (this.formValiEditResult.items[k].windSpeed>100||this.formValiEditResult.items[k].windSpeed<-100))
                        {
                            allAindSpeed = false;
                            return false;
                        }
                    }
                })
                if(allAindSpeed)
                {
                    // this.formValiEditResult.items.forEach((v,k)=>{
                    //     if(this.formValiEditResult.items[k].windSpeed)
                    //     {
                    //         this.formValiEditResult.items[k].windSpeed = Number(v.windSpeed)*100;
                    //     }
                    // })
                    
                    let data =  this.$PlugIn.deepClone(this.formValiEditResult);
                    
                    data.items.forEach((v,k)=>{
                        if(data.items[k].windSpeed)
                        {
                            data.items[k].windSpeed = Number(v.windSpeed)*100;
                        }
                    })
                    addAlleventscore(data).then( (res) => {
                        this.MessageFn(res,eit);
                    }).catch((error) => {
                        
                    })
                }else{
                    this.$Message.error('风速超出范围值！');
                }
                
            }
      },
      MessageFn(res,eit)
      {
            this.loadings()
            
            if(res.data.code==0)
            {
                if(!this.resultForm.addData)
                {
                    
                    this.$emit('ModalResultListShow');
                    this.$Message.info("编辑成功");
                }else{
                    
                    
                    
                    if(eit)
                    {
                        this.$Message.info('添加成功');
                        this.$emit('ModalResultListShow');
                    }else{
                        if(this.getResult.property!==4)
                        {
                            this.sportsmanListModal = true;
                        }
                        this.$Message.info({
                            content: '添加成功并继续录入成绩',
                            duration: 3,
                            closable: true
                        });
                    }
                    // this.resultForm.imageUrl = '';
                    this.$emit('imageUrlUp');
                    this.defaultListUp();
                }
                this.$Spin.hide();
                this.handleReset('formValiEditResult');
                this.$emit('resultUp');                
            }else if(res.data.code == -2){
                this.$Message.error("获取失败");
                this.$Spin.hide();
            }else if(res.data.code==10)
            {
                this.$Message.info("登录token过期请重新登录");
                this.$store.dispatch('loginOut');
            }else{
                this.$Message.error(res.data.msg);
                this.$Spin.hide();
            }
      },
      trim(s)  
      {
        return s.replace(/(^\s*)|(\s*$)/g, '');
      },
      getSportsmanListFn()
      {
          
          this.SportsmanName=this.trim(this.SportsmanName);
          let authorities = JSON.parse(localStorage.authorities);
          console.log(authorities.length)
          let data = {
            cnName:this.SportsmanName,
            registerYear:this.sporterLimits==0 ? this.registerYear :  this.stampTiemY ,
            page_size:100,
            unit:null
          }
          if(this.resultForm.sexType===0||this.resultForm.sexType===1)
          {
              data.sex = this.resultForm.sexType;
          }
          for(let i = 0; i<authorities.length; i++)
          {
              if( authorities[i] === this.$PlugIn.role.admin || this.getResult.property== 4 || authorities[i] === this.$PlugIn.role.entryAdmin || authorities[i] === this.$PlugIn.role.countriesEntry || authorities[i] ===this.$PlugIn.role.unitEntry)
              {
                  data.unit = localStorage.unit ? JSON.parse(localStorage.unit) : null ;
                  break;
              }
          }
          
          if(this.SportsmanName!=='')
          {
                getSportsmanList(data).then(res => {
                    if(res.data.code == 0){
                        this.getSportsmanListData = res.data.data.results;
                    }else if(res.data.code == -2){
                        this.$Message.error("获取失败");
                    }else if(res.data.code==10)
                    {
                        this.$Message.info("登录token过期请重新登录");
                        this.$store.dispatch('loginOut');
                    }else{
                        this.$Message.error(res.data.msg);
                    }
                },err =>{
                    this.$Message.error("网络连接失败");
                });
          }else{
              this.getSportsmanListData = [];
              this.$Message.info("姓名不能不为空！");
          }
      },
      selectSportsman(item,index)
      {

          this.getSportsmanData = {
                sex:item.sexString,
                cnName:item.cnName,
                enFirstName:item.enFirstName,
                enLastName:item.enLastName,
                iDCard:item.idCard,
                iAAFAthleteCode:item.registerNo,
                unit:item.unit,
                unitID:item.unitID
          }
          
          let sportsmanTable = document.getElementById('sportsmanTable').getElementsByTagName('tr');
          for(let i = 0; i<sportsmanTable.length; i++)
          {
              sportsmanTable[i].className = '';
          }
          sportsmanTable[index].className = 'on';
      },
      sportsmanSubmit()
      {
          if(this.SportsmanName !== '' && this.getSportsmanListData.length && this.getSportsmanData.iDCard)
          {
                this.sportsmanListModal = false;
                
                let obj = this.$PlugIn.deepClone(this.getSportsmanData);
                if(this.getResult.property===4)
                {

                    this.formValiEditResult.items[this.SportsmanIndex] = {
                        familyNameCHN:obj.cnName,
                        enFirstName:obj.enFirstName,
                        enLastName:obj.enLastName,
                        iDCard:obj.iDCard,
                        iAAFAthleteCode:obj.iAAFAthleteCode,
                        unitNameCHN:obj.unit,
                        sex:obj.sex,
                        unitID:obj.unitID,
                        index: this.SportsmanIndex,
                        value:this.SportsmanIndex+1,
                    }
                }else{
                    this.formValiEditResult.familyNameCHN=obj.cnName;
                    this.formValiEditResult.enFirstName=obj.enFirstName;
                    this.formValiEditResult.enLastName=obj.enLastName;
                    this.formValiEditResult.iDCard=obj.iDCard;
                    this.formValiEditResult.iAAFAthleteCode=obj.iAAFAthleteCode;
                    this.formValiEditResult.unitNameCHN=obj.unit;
                    this.formValiEditResult.unitID=obj.unitID,
                    this.formValiEditResult.sex=obj.sex;
                }
              
                this.SportsmanName = '';
                this.getSportsmanListData = [];
                this.getSportsmanData = {
                    sex:'',
                    cnName:'',
                    enFirstName:'',
                    enLastName:'',
                    iDCard:'',
                    iAAFAthleteCode:'',
                    unit:'',
                    unitID:'',
                }
          }else{
              this.$Message.info("请选择选择运动员");
          }
      },
      addSportsman(num)
      {
          if(this.getResult.property===4)
          {
              this.SportsmanIndex = num;
          }
          
          this.sportsmanListModal=true
      },
      Sportsmancancel()
      {
          this.fileUrl = '';
          this.SportsmanName = '';
          this.getSportsmanListData = [];
      },
      closeModalResultList()
      {
        this.handleReset('formValiEditResult');
        this.imageUrl = '';
        this.showResultDefaults = '';
      },
     
  },
  created(){
      
  },
  mounted(){
     getEventList().then(res => {
            if(res.data.code == 0){
                // EventTypeTrack(1, "径赛"), 
                // EventTypeHigh(2, "田高"), 
                // EventTypeFar(3, "田远"), 
                // EventTypeRelay(4,"接力"), 
                // EventTypeAll(5, "全能"),
                // EventTypeWalk(6, "竞走"),
                // EventTypeMarathon(7, "马拉松")
                this.eventListData = res.data.data;
            
            }else if(res.data.code == -2){
                this.$Message.error("获取失败");
            }else if(res.data.code==10)
            {
                this.$Message.info("登录token过期请重新登录");
                this.$store.dispatch('loginOut');
            }else{
                this.$Message.error(res.data.msg);
            }
        },err =>{
            this.$Message.error("网络连接失败");
        });
     
  }
     
}
</script>
<style scoped  lang="less">
    .UpBut{text-align: center;}
    .sportsmanTable{width: 100%;text-align: center;}
    .sportsmanTableTbody{max-height: 400px;overflow-y:auto;margin-top: -1px;border-bottom: 1px solid #ddd;}
    .sportsmanTableHead{margin-top: 12px;}
    .sportsmanTable th,.sportsmanTable td{padding: 6px 3px;}
    .sportsmanSubmit{padding-top: 22px;}
    .getSportsman{height: 12px;width: 12px;background: #ccc;box-shadow: 1px 1px 1px #999;}
    .sportsmanTable tr.on .getSportsman{background: #30a5ff;}
    .sportsmanTable tr.on td{background: #eee;}
    .highJump span{text-align: right;margin-right: 8px;}
    .highJump{margin-bottom: 12px;}
    .handleAdd{margin-left: 120px;max-width:180px;padding-bottom: 12px;}
    .editDiv .ti{padding-left: 120px;}
    .demo-upload-list{
        display: inline-block;
        width: 110px;
        height: 110px;
        text-align: center;
        line-height: 110px;
        border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 1px rgba(0,0,0,.2);
        
    }
    .uploadImg{padding-left: 120px; }
    .uploadImgBox{width: 112px;
        height: 112px;border:1px dashed #ddd;overflow: hidden;}
    .demo-upload-list img{
        width: 100%;
        height: 100%;
    }
    .demo-upload-list-cover{
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0,0,0,.6);
    }
    .demo-upload-list:hover .demo-upload-list-cover{
        display: block;
    }
    .demo-upload-list-cover i{
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        margin: 0 2px;
    }
    .uploadbox{padding: 12px 0;}
</style>


// WEBPACK FOOTER //
// src/components/result.vue